import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface CorporateIdentityProps {}

const CorporateIdentity = ({}: CorporateIdentityProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Corporate Identity")}
          subtitle={t("Services")}
          thirdTitle={t("Corporate Identity")}
        />
        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/Corporateidentity.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "A company’s name, logo, typeface, colors, slogan, etc., are elements that help comprise its corporate identity. It will easily bridge the gap between strategy and imagination. Everyone has a name and a unique identity, so your business should have too. We can brand your business to make you stand out from your competitors. Our expert branding services ensure your identity resonates with your target audience, forging lasting connections and fostering brand loyalty. Let us elevate your brand identity to reflect the essence of your business, ensuring a cohesive and memorable presence across all platforms."
              )}
            </p>
          </div>
        </section>

        {/*  Our core service is developing **************/}
        <section className="my-[100px] px-[20px] lg:px-[140px] w-full flex flex-col gap-10 items-center justify-center">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Visual Strategy Process")}
          </p>
          <div className="w-full h-[65px] rounded-[20px] bg-gradient-to-r from-[#E4002F] to-[#0804B5] flex items-center justify-center text-[12px] lg:text-[20px] font-[500] text-white text-center">
            {t("We learn about your goals and preferences carefully.")}
          </div>
          <div className="w-full h-[65px] rounded-[20px] bg-gradient-to-r from-[#E4002F] to-[#0804B5] flex items-center justify-center text-[12px] lg:text-[20px] font-[500] text-white text-center">
            {t(
              "We summarize and categorize what is really important and how to express visually."
            )}
          </div>
          <div className="w-full h-[65px] rounded-[20px] bg-gradient-to-r from-[#E4002F] to-[#0804B5] flex items-center justify-center text-[12px] lg:text-[20px] font-[500] text-white text-center">
            {t("We present to you, listen to your opinions and finalize.")}
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default CorporateIdentity;
